(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("colorService", ["$q", "$rootScope", "tenantResource", colorService]);
    function colorService($q, $rootScope, tenantResource) {
        var colorServiceFactory = {};
        //Default primary and secondary colors
        var _primaryColor = "#0069aa";
        var _secondaryColor = "#577e9a";
        var _primaryTextColor = "";
        var _secondaryTextColor = "";
        var _previewPrimary = "";
        var _previewSecondary = "";
        var _previewPrimaryText = "";
        var _previewSecondaryText = "";
        var _successColor = "#a2cc39";
        var _dangerColor = "#E54328";
        var _warningColor = "#fbb033";
        function setSiteColors(primaryColor, secondaryColor, primaryTextColor, secondaryTextColor) {
            if (primaryColor !== null && primaryColor !== undefined && primaryColor !== "")
                _primaryColor = primaryColor;
            if (secondaryColor !== null && secondaryColor !== undefined && secondaryColor !== "")
                _secondaryColor = secondaryColor;
            if (primaryTextColor !== null && primaryTextColor !== undefined)
                _primaryTextColor = primaryTextColor;
            else
                _primaryTextColor = "";
            if (secondaryTextColor !== null && secondaryTextColor !== undefined)
                _secondaryTextColor = secondaryTextColor;
            else
                _secondaryTextColor = "";
            changeColors(_primaryColor, _secondaryColor, _primaryTextColor, _secondaryTextColor);
            $rootScope.$broadcast("siteColorChanged", {
                primaryColor: _primaryColor,
                secondaryColor: _secondaryColor,
                primaryTextColor: _primaryTextColor,
                secondaryTextColor: _secondaryTextColor
            });
        }
        function previewSiteColors(primaryColor, secondaryColor, primaryTextColor, secondaryTextColor, fromA2) {
            if (fromA2 === void 0) { fromA2 = false; }
            if (primaryColor !== null && primaryColor !== undefined && primaryColor !== "")
                _previewPrimary = primaryColor;
            if (secondaryColor !== null && secondaryColor !== undefined && secondaryColor !== "")
                _previewSecondary = secondaryColor;
            if (primaryTextColor !== null && primaryTextColor !== undefined)
                _previewPrimaryText = primaryTextColor;
            else
                _previewPrimaryText = "";
            if (secondaryTextColor !== null && secondaryTextColor !== undefined)
                _previewSecondaryText = secondaryTextColor;
            else
                _previewSecondaryText = "";
            changeColors(primaryColor, secondaryColor, primaryTextColor, secondaryTextColor);
            if (!fromA2)
                $rootScope.$broadcast("previewAngularTheme", { pc: primaryColor, sc: secondaryColor, ptc: primaryTextColor, stc: secondaryTextColor });
            //^^this listener activates the previewNavBar for A2
            /*$rootScope.$broadcast("siteColorPreviewed",
                {
                    primaryColor: _primaryColor,
                    secondaryColor: _secondaryColor,
                    primaryTextColor: _primaryTextColor,
                    secondaryTextColor: _secondaryTextColor
                });*/
        }
        function resetSiteColors() {
            changeColors(_primaryColor, _secondaryColor, _primaryTextColor, _secondaryTextColor);
            /*$rootScope.$broadcast("siteColorChanged",
                {
                    primaryColor: _primaryColor,
                    secondaryColor: _secondaryColor,
                    primaryTextColor: _primaryTextColor,
                    secondaryTextColor: _secondaryTextColor
                });*/
        }
        function changeColors(primaryColor, secondaryColor, primaryTextColor, secondaryTextColor) {
            //console.log("ANGULAR JS changeColors called");
            if (!primaryTextColor || primaryTextColor.trim() === "") {
                primaryTextColor = window.tinycolor.mostReadable(primaryColor, ["#fff", "#000"]);
            }
            if (!secondaryTextColor || secondaryTextColor.trim() === "") {
                secondaryTextColor = window.tinycolor.mostReadable(secondaryColor, ["#fff", "#000"]);
            }
            var primaryMonochromaticList = window.tinycolor(primaryColor).monochromatic(4);
            var secondaryMonochromaticList = window.tinycolor(secondaryColor).monochromatic(4);
            //Removes the first occurence which is equals the color used to get the monochromatic list
            delete primaryMonochromaticList[0];
            delete secondaryMonochromaticList[0];
            //Sort the list from the lightest to the darkest color
            primaryMonochromaticList.sort(function (a, b) {
                return a.toHsl().l < b.toHsl().l;
            });
            secondaryMonochromaticList.sort(function (a, b) {
                return a.toHsl().l < b.toHsl().l;
            });
            //var primaryColorborder = primaryMonochromaticList[0];
            var primaryColorborder = primaryColor;
            var primaryColorActive = primaryMonochromaticList[1];
            var primaryColorActiveFocus = primaryMonochromaticList[2];
            //var secondaryColorborder = secondaryMonochromaticList[0];
            var secondaryColorborder = secondaryColor;
            var secondaryColorActive = secondaryMonochromaticList[1];
            var secondaryColorActiveFocus = secondaryMonochromaticList[2];
            // ReSharper disable once UndeclaredGlobalVariableUsing
            //	less.modifyVars({
            //		'@color-primary': primaryColor,
            //		'@color-primary-active': primaryColorActive,
            //		'@color-primary-active-focus': primaryColorActiveFocus,
            //		'@color-primary-border': primaryColorborder,
            //		'@color-primary-text': primaryTextColor,
            //		'@color-primary-active-text': window.tinycolor.mostReadable(primaryColorActive, ["#fff", "#000"]),
            //		'@color-primary-active-focus-text': window.tinycolor.mostReadable(primaryColorActiveFocus, ["#fff", "#000"]),
            //		'@color-secondary': secondaryColor,
            //		'@color-secondary-active': secondaryColorActive,
            //		'@color-secondary-active-focus': secondaryColorActiveFocus,
            //		'@color-secondary-border': secondaryColorborder,
            //		'@color-secondary-text': secondaryTextColor,
            //		'@color-secondary-active-text': window.tinycolor.mostReadable(secondaryColorActive, ["#fff", "#000"]),
            //		'@color-secondary-active-focus-text': window.tinycolor.mostReadable(secondaryColorActiveFocus, ["#fff", "#000"])
            //	});
        }
        function getPrimaryColor() {
            return _primaryColor;
        }
        function getSecondaryColor() {
            return _secondaryColor;
        }
        function getPrimaryTextColor() {
            return _primaryTextColor;
        }
        function getSecondaryTextColor() {
            return _secondaryTextColor;
        }
        function getSuccessColor() {
            return _successColor;
        }
        function getWarningColor() {
            return _warningColor;
        }
        function getDangerColor() {
            return _dangerColor;
        }
        function saveColors(primaryColor, secondaryColor, primaryTextColor, secondaryTextColor) {
            return $q(function (resolve, reject) {
                var data = {
                    primaryColor: primaryColor ? primaryColor : _previewPrimary,
                    secondaryColor: secondaryColor ? secondaryColor : _previewSecondary,
                    primaryTextColor: primaryTextColor ? primaryTextColor : _previewPrimaryText,
                    secondaryTextColor: secondaryTextColor ? secondaryTextColor : _previewSecondaryText
                };
                tenantResource.saveColors(data, function () {
                    setSiteColors(data.primaryColor, data.secondaryColor, data.primaryTextColor, data.secondaryTextColor);
                    resolve();
                }, function () {
                    reject();
                });
            });
        }
        function getLogoPalette() {
            return $q(function (resolve, reject) {
                tenantResource.getLogoPalette(function (result) {
                    resolve(result);
                }, function () {
                    reject();
                });
            });
        }
        colorServiceFactory.setSiteColors = setSiteColors;
        colorServiceFactory.getPrimaryColor = getPrimaryColor;
        colorServiceFactory.getSecondaryColor = getSecondaryColor;
        colorServiceFactory.getPrimaryTextColor = getPrimaryTextColor;
        colorServiceFactory.getSecondaryTextColor = getSecondaryTextColor;
        colorServiceFactory.previewSiteColors = previewSiteColors;
        colorServiceFactory.resetSiteColors = resetSiteColors;
        colorServiceFactory.saveColors = saveColors;
        colorServiceFactory.getLogoPalette = getLogoPalette;
        colorServiceFactory.getSuccessColor = getSuccessColor;
        colorServiceFactory.getWarningColor = getWarningColor;
        colorServiceFactory.getDangerColor = getDangerColor;
        return colorServiceFactory;
    }
}());
export {};
